export interface LanguageInfo {
    code: string,
    label: string,
    nativeLabel: string,
    countryCode: string,
    seamlessCode: string,
    countryCodes: { countryCode: string, flag: string }[],
    youtubeCode?: string // YouTube-specific locale code (e.g., 'en_US', 'pt_BR')
}

// export const languages: LanguageInfo[] = [
//     {"label": "Bulgarian", "code": "bg", "nativeLabel": "Български", "countryCode": "BG", countryCodes: ["BG"]},
//     {"label": "Chinese", "code": "zh", "nativeLabel": "中文", "countryCode": "CN", countryCodes: ["CN", "TW", "SG", "MY", "HK"]},
//     {"label": "Classic Arabic", "code": "ar", "nativeLabel": "العربية الفصحى", "countryCode": "SA", countryCodes: ["SA", "AE", "EG", "DZ", "MA", "LY", "OM", "KW", "QA"]},
//     {"label": "Croatian", "code": "hr", "nativeLabel": "Hrvatski", "countryCode": "HR", countryCodes: ["HR"]},
//     {"label": "Czech", "code": "cs", "nativeLabel": "Čeština", "countryCode": "CZ", countryCodes: ["CZ"]},
//     {"label": "Danish", "code": "da", "nativeLabel": "Dansk", "countryCode": "DK", countryCodes: ["DK"]},
//     {"label": "Dutch", "code": "nl", "nativeLabel": "Nederlands", "countryCode": "NL", countryCodes: ["NL", "BE", "SR"]},
//     {"label": "English", "code": "en", "nativeLabel": "English", "countryCode": "AU", countryCodes: ["US", "GB", "AU", "CA", "IN", "NZ", "ZA", "IE", "UK", "SE"]},
//     {"label": "Finnish", "code": "fi", "nativeLabel": "Suomi", "countryCode": "FI", countryCodes: ["FI"]},
//     {"label": "Filipino", "code": "tl", "nativeLabel": "Filipino", "countryCode": "PH", countryCodes: ["PH"]},
//     {"label": "French", "code": "fr", "nativeLabel": "Français", "countryCode": "FR", countryCodes: ["FR", "BE", "CA", "CH", "LU", "MC"]},
//     {"label": "German", "code": "de", "nativeLabel": "Deutsch", "countryCode": "DE", countryCodes: ["DE", "AT", "CH", "LI", "LU"]},
//     {"label": "Greek", "code": "el", "nativeLabel": "Ελληνικά", "countryCode": "GR", countryCodes: ["GR", "CY"]},
//     {"label": "Hindi", "code": "hi", "nativeLabel": "हिन्दी", "countryCode": "IN", countryCodes: ["IN", "FJ"]},
//     {"label": "Indonesian", "code": "id", "nativeLabel": "Bahasa Indonesia", "countryCode": "ID", countryCodes: ["ID"]},
//     {"label": "Italian", "code": "it", "nativeLabel": "Italiano", "countryCode": "IT", countryCodes: ["IT", "CH", "SM", "VA"]},
//     {"label": "Japanese", "code": "ja", "nativeLabel": "日本語", "countryCode": "JP", countryCodes: ["JP"]},
//     {"label": "Korean", "code": "ko", "nativeLabel": "한국어", "countryCode": "KR", countryCodes: ["KR"]},
//     {"label": "Malay", "code": "ms", "nativeLabel": "Bahasa Melayu", "countryCode": "MY", countryCodes: ["MY", "BN", "SG"]},
//     {"label": "Polish", "code": "pl", "nativeLabel": "Polski", "countryCode": "PL", countryCodes: ["PL"]},
//     {"label": "Portuguese", "code": "pt", "nativeLabel": "Português", "countryCode": "PT", countryCodes: ["PT", "BR", "MZ", "AO"]},
//     {"label": "Romanian", "code": "ro", "nativeLabel": "Română", "countryCode": "RO", countryCodes: ["RO", "MD"]},
//     {"label": "Russian", "code": "ru", "nativeLabel": "Русский", "countryCode": "RU", countryCodes: ["RU", "BY", "KZ", "KG", "UA"]},
//     {"label": "Slovak", "code": "sk", "nativeLabel": "Slovenčina", "countryCode": "SK", countryCodes: ["SK"]},
//     {"label": "Spanish", "code": "es", "nativeLabel": "Español", "countryCode": "ES", countryCodes: ["ES", "MX", "AR", "CO", "CL", "PE", "VE", "US"]},
//     {"label": "Swedish", "code": "sv", "nativeLabel": "Svenska", "countryCode": "SE", countryCodes: ["SE", "FI"]},
//     {"label": "Tamil", "code": "ta", "nativeLabel": "தமிழ்", "countryCode": "IN", countryCodes: ["IN", "LK", "SG", "MY"]},
//     {"label": "Turkish", "code": "tr", "nativeLabel": "Türkçe", "countryCode": "TR", countryCodes: ["TR", "CY"]},
//     {"label": "Ukrainian", "code": "uk", "nativeLabel": "Українська", "countryCode": "UA", countryCodes: ["UA"]}
// ];

const languagesRaw: LanguageInfo[] = [
    {
        "label": "Bulgarian",
        "code": "bg",
        "seamlessCode": "bul",
        "nativeLabel": "Български",
        "countryCode": "BG",
        "countryCodes": [
            {"countryCode": "BG", "flag": "🇧🇬"}
        ]
    },
    {
        "label": "Chinese",
        "code": "zh",
        "seamlessCode": "cmn",
        "nativeLabel": "中文",
        "countryCode": "CN",
        "countryCodes": [
            {"countryCode": "CN", "flag": "🇨🇳"},
            {"countryCode": "TW", "flag": "🇹🇼"},
            // {"countryCode": "SG", "flag": "🇸🇬"},
            // {"countryCode": "MY", "flag": "🇲🇾"},
            {"countryCode": "HK", "flag": "🇭🇰"}
        ]
    },
    {
        "label": "Classic Arabic",
        "code": "ar",
        "seamlessCode": "arb",
        "nativeLabel": "العربية الفصحى",
        "countryCode": "AE",
        "countryCodes": [
            {"countryCode": "SA", "flag": "🇸🇦"},
            {"countryCode": "AE", "flag": "🇦🇪"},
            {"countryCode": "EG", "flag": "🇪🇬"},
            // {"countryCode": "DZ", "flag": "🇩🇿"},
            // {"countryCode": "MA", "flag": "🇲🇦"},
            // {"countryCode": "LY", "flag": "🇱🇾"},
            // {"countryCode": "OM", "flag": "🇴🇲"},
            // {"countryCode": "KW", "flag": "🇰🇼"},
            {"countryCode": "QA", "flag": "🇶🇦"}
        ]
    },
    // {
    //     "label": "Croatian",
    //     "code": "hr",
    //     "nativeLabel": "Hrvatski",
    //     "countryCode": "HR",
    //     "countryCodes": [
    //         {"countryCode": "HR", "flag": "🇭🇷"}
    //     ]
    // },
    {
        "label": "Czech",
        "code": "cs",
        "seamlessCode": "ces",
        "nativeLabel": "Čeština",
        "countryCode": "CZ",
        "countryCodes": [
            {"countryCode": "CZ", "flag": "🇨🇿"}
        ]
    },
    {
        "label": "Danish",
        "code": "da",
        "seamlessCode": "dan",
        "nativeLabel": "Dansk",
        "countryCode": "DK",
        "countryCodes": [
            {"countryCode": "DK", "flag": "🇩🇰"}
        ]
    },
    {
        "label": "Dutch",
        "code": "nl",
        "seamlessCode": "nld",
        "nativeLabel": "Nederlands",
        "countryCode": "NL",
        "countryCodes": [
            {"countryCode": "NL", "flag": "🇳🇱"},
            {"countryCode": "BE", "flag": "🇧🇪"},
            {"countryCode": "SR", "flag": "🇸🇷"}
        ]
    },
    {
        "label": "English",
        "code": "en",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "US",
        "countryCodes": [
            {"countryCode": "US", "flag": "🇺🇸"},
            {"countryCode": "GB", "flag": "🇬🇧"},
            {"countryCode": "AU", "flag": "🇦🇺"},
            {"countryCode": "CA", "flag": "🇨🇦"},
            // {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "NZ", "flag": "🇳🇿"},
            // {"countryCode": "ZA", "flag": "🇿🇦"},
            // {"countryCode": "IE", "flag": "🇮🇪"},
            // {"countryCode": "UK", "flag": "🇬🇧"},
            // {"countryCode": "SE", "flag": "🇸🇪"},
            // {"countryCode": "WLS", "flag": "🏴󠁧󠁢󠁷󠁬󠁳󠁿"}
        ]
    },
    {
        "label": "English (AU)",
        "code": "en-AU",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "AU",
        "countryCodes": [{"countryCode": "AU", "flag": "🇦🇺"}],
        "youtubeCode": "en_AU"
    },
    {
        "label": "English (UK)",
        "code": "en-GB",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "GB",
        "countryCodes": [{"countryCode": "GB", "flag": "🇬🇧"}],
        "youtubeCode": "en_GB"
    },
    {
        "label": "English (US)",
        "code": "en-US",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "US",
        "countryCodes": [{"countryCode": "US", "flag": "🇺🇸"}],
        "youtubeCode": "en_US"
    },
    {
        "label": "Finnish",
        "code": "fi",
        "seamlessCode": "fin",
        "nativeLabel": "Suomi",
        "countryCode": "FI",
        "countryCodes": [
            {"countryCode": "FI", "flag": "🇫🇮"}
        ]
    },
    // {
    //     "label": "Filipino",
    //     "code": "tl",
    //     "nativeLabel": "Filipino",
    //     "countryCode": "PH",
    //     "countryCodes": [
    //         {"countryCode": "PH", "flag": "🇵🇭"}
    //     ]
    // },
    {
        "label": "French",
        "code": "fr",
        "seamlessCode": "fra",
        "nativeLabel": "Français",
        "countryCode": "FR",
        "countryCodes": [
            {"countryCode": "FR", "flag": "🇫🇷"},
            {"countryCode": "BE", "flag": "🇧🇪"},
            {"countryCode": "CA", "flag": "🇨🇦"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "LU", "flag": "🇱🇺"},
            {"countryCode": "MC", "flag": "🇲🇨"}
        ]
    },
    {
        "label": "French (FR)",
        "code": "fr-FR",
        "seamlessCode": "fra",
        "nativeLabel": "Français",
        "countryCode": "FR",
        "countryCodes": [{"countryCode": "FR", "flag": "🇫🇷"}],
        "youtubeCode": "fr_FR"
    },
    {
        "label": "French (CA)",
        "code": "fr-CA",
        "seamlessCode": "fra",
        "nativeLabel": "Français",
        "countryCode": "CA",
        "countryCodes": [{"countryCode": "CA", "flag": "🇨🇦"}],
        "youtubeCode": "fr_CA"
    },
    {
        "label": "German",
        "code": "de",
        "seamlessCode": "deu",
        "nativeLabel": "Deutsch",
        "countryCode": "DE",
        "countryCodes": [
            {"countryCode": "DE", "flag": "🇩🇪"},
            {"countryCode": "AT", "flag": "🇦🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "LI", "flag": "🇱🇮"},
            {"countryCode": "LU", "flag": "🇱🇺"}
        ]
    },
    {
        "label": "Greek",
        "code": "el",
        "seamlessCode": "ell",
        "nativeLabel": "Ελληνικά",
        "countryCode": "GR",
        "countryCodes": [
            {"countryCode": "GR", "flag": "🇬🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ]
    },
    {
        "label": "Hindi",
        "code": "hi",
        "seamlessCode": "hin",
        "nativeLabel": "हिन्दी",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "FJ", "flag": "🇫🇯"}
        ]
    },
    {
        "label": "Indonesian",
        "code": "id",
        "seamlessCode": "ind",
        "nativeLabel": "Bahasa Indonesia",
        "countryCode": "ID",
        "countryCodes": [
            {"countryCode": "ID", "flag": "🇮🇩"}
        ]
    },
    {
        "label": "Italian",
        "code": "it",
        "seamlessCode": "ita",
        "nativeLabel": "Italiano",
        "countryCode": "IT",
        "countryCodes": [
            {"countryCode": "IT", "flag": "🇮🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "SM", "flag": "🇸🇲"},
            {"countryCode": "VA", "flag": "🇻🇦"}
        ]
    },
    {
        "label": "Japanese",
        "code": "ja",
        "seamlessCode": "jpn",
        "nativeLabel": "日本語",
        "countryCode": "JP",
        "countryCodes": [
            {"countryCode": "JP", "flag": "🇯🇵"}
        ]
    },
    {
        "label": "Korean",
        "code": "ko",
        "seamlessCode": "kor",
        "nativeLabel": "한국어",
        "countryCode": "KR",
        "countryCodes": [
            {"countryCode": "KR", "flag": "🇰🇷"}
        ]
    },
    {
        "label": "Malay",
        "code": "ms",
        "seamlessCode": "msa",
        "nativeLabel": "Bahasa Melayu",
        "countryCode": "MY",
        "countryCodes": [
            {"countryCode": "MY", "flag": "🇲🇾"},
            {"countryCode": "BN", "flag": "🇧🇳"},
            {"countryCode": "SG", "flag": "🇸🇬"}
        ]
    },
    {
        "label": "Polish",
        "code": "pl",
        "seamlessCode": "pol",
        "nativeLabel": "Polski",
        "countryCode": "PL",
        "countryCodes": [
            {"countryCode": "PL", "flag": "🇵🇱"}
        ]
    },
    {
        "label": "Portuguese",
        "code": "pt",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "BR",
        "countryCodes": [
            {"countryCode": "PT", "flag": "🇵🇹"},
            {"countryCode": "BR", "flag": "🇧🇷"},
            {"countryCode": "MZ", "flag": "🇲🇿"},
            {"countryCode": "AO", "flag": "🇦🇴"}
        ]
    },
    {
        "label": "Portuguese (BR)",
        "code": "pt-BR",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "BR",
        "countryCodes": [{"countryCode": "BR", "flag": "🇧🇷"}],
        "youtubeCode": "pt_BR"
    },
    {
        "label": "Portuguese (PT)",
        "code": "pt-PT",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "PT",
        "countryCodes": [{"countryCode": "PT", "flag": "🇵🇹"}],
        "youtubeCode": "pt_PT"
    },
    {
        "label": "Romanian",
        "code": "ro",
        "seamlessCode": "ron",
        "nativeLabel": "Română",
        "countryCode": "RO",
        "countryCodes": [
            {"countryCode": "RO", "flag": "🇷🇴"},
            {"countryCode": "MD", "flag": "🇲🇩"}
        ]
    },
    {
        "label": "Russian",
        "code": "ru",
        "seamlessCode": "rus",
        "nativeLabel": "Русский",
        "countryCode": "RU",
        "countryCodes": [
            {"countryCode": "RU", "flag": "🇷🇺"},
            {"countryCode": "BY", "flag": "🇧🇾"},
            {"countryCode": "KZ", "flag": "🇰🇿"},
            {"countryCode": "KG", "flag": "🇰🇬"},
            {"countryCode": "UA", "flag": "🇺🇦"}
        ]
    },
    {
        "label": "Slovak",
        "code": "sk",
        "seamlessCode": "slk",
        "nativeLabel": "Slovenčina",
        "countryCode": "SK",
        "countryCodes": [
            {"countryCode": "SK", "flag": "🇸🇰"}
        ]
    },
    {
        "label": "Spanish",
        "code": "es",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "MX",
        "countryCodes": [
            {"countryCode": "MX", "flag": "🇲🇽"},
            {"countryCode": "ES", "flag": "🇪🇸"},
            {"countryCode": "AR", "flag": "🇦🇷"},
            {"countryCode": "CO", "flag": "🇨🇴"},
            // {"countryCode": "CL", "flag": "🇨🇱"},
            // {"countryCode": "PE", "flag": "🇵🇪"},
            // {"countryCode": "VE", "flag": "🇻🇪"},
            // {"countryCode": "US", "flag": "🇺🇸"}
        ]
    },
    {
        "label": "Spanish (ES)",
        "code": "es-ES",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "ES",
        "countryCodes": [{"countryCode": "ES", "flag": "🇪🇸"}],
        "youtubeCode": "es_ES"
    },
    {
        "label": "Spanish (MX)",
        "code": "es-MX",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "MX",
        "countryCodes": [{"countryCode": "MX", "flag": "🇲🇽"}],
        "youtubeCode": "es_MX"
    },
    {
        "label": "Swedish",
        "code": "sv",
        "seamlessCode": "swe",
        "nativeLabel": "Svenska",
        "countryCode": "SE",
        "countryCodes": [
            {"countryCode": "SE", "flag": "🇸🇪"},
            {"countryCode": "FI", "flag": "🇫🇮"}
        ]
    },
    {
        "label": "Tamil",
        "code": "ta",
        "seamlessCode": "tam",
        "nativeLabel": "தமிழ்",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "LK", "flag": "🇱🇰"},
            {"countryCode": "SG", "flag": "🇸🇬"},
            {"countryCode": "MY", "flag": "🇲🇾"}
        ]
    },
    {
        "label": "Turkish",
        "code": "tr",
        "seamlessCode": "tur",
        "nativeLabel": "Türkçe",
        "countryCode": "TR",
        "countryCodes": [
            {"countryCode": "TR", "flag": "🇹🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ]
    },
    {
        "label": "Afrikaans",
        "code": "af",
        "seamlessCode": "afr",
        "nativeLabel": "Afrikaans",
        "countryCode": "ZA",
        "countryCodes": [
            {"countryCode": "ZA", "flag": "🇿🇦"}
        ]
    },
    {
        "label": "Amharic",
        "code": "am",
        "seamlessCode": "amh",
        "nativeLabel": "አማርኛ",
        "countryCode": "ET",
        "countryCodes": [
            {"countryCode": "ET", "flag": "🇪🇹"}
        ]
    },
    {
        "label": "Armenian",
        "code": "hy",
        "seamlessCode": "hye",
        "nativeLabel": "Հայերեն",
        "countryCode": "AM",
        "countryCodes": [
            {"countryCode": "AM", "flag": "🇦🇲"}
        ]
    },
    {
        "label": "Assamese",
        "code": "as",
        "seamlessCode": "asm",
        "nativeLabel": "অসমীয়া",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Asturian",
        "code": "ast",
        "seamlessCode": "ast",
        "nativeLabel": "Asturianu",
        "countryCode": "ES",
        "countryCodes": [
            {"countryCode": "ES", "flag": "🇪🇸"}
        ]
    },
    {
        "label": "Azerbaijani",
        "code": "az",
        "seamlessCode": "aze",
        "nativeLabel": "Azərbaycanca",
        "countryCode": "AZ",
        "countryCodes": [
            {"countryCode": "AZ", "flag": "🇦🇿"}
        ]
    },
    {
        "label": "Belarusian",
        "code": "be",
        "seamlessCode": "bel",
        "nativeLabel": "Беларуская",
        "countryCode": "BY",
        "countryCodes": [
            {"countryCode": "BY", "flag": "🇧🇾"}
        ]
    },
    {
        "label": "Bengali",
        "code": "bn",
        "seamlessCode": "ben",
        "nativeLabel": "বাংলা",
        "countryCode": "BD",
        "countryCodes": [
            {"countryCode": "BD", "flag": "🇧🇩"},
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Bosnian",
        "code": "bs",
        "seamlessCode": "bos",
        "nativeLabel": "Bosanski",
        "countryCode": "BA",
        "countryCodes": [
            {"countryCode": "BA", "flag": "🇧🇦"}
        ]
    },
    {
        "label": "Burmese",
        "code": "my",
        "seamlessCode": "mya",
        "nativeLabel": "မြန်မာ",
        "countryCode": "MM",
        "countryCodes": [
            {"countryCode": "MM", "flag": "🇲🇲"}
        ]
    },
    {
        "label": "Cantonese",
        "code": "yue",
        "seamlessCode": "yue",
        "nativeLabel": "廣東話",
        "countryCode": "HK",
        "countryCodes": [
            {"countryCode": "HK", "flag": "🇭🇰"},
            {"countryCode": "MO", "flag": "🇲🇴"}
        ]
    },
    {
        "label": "Catalan",
        "code": "ca",
        "seamlessCode": "cat",
        "nativeLabel": "Català",
        "countryCode": "ES",
        "countryCodes": [
            {"countryCode": "ES", "flag": "🇪🇸"}
        ]
    },
    {
        "label": "Cebuano",
        "code": "ceb",
        "seamlessCode": "ceb",
        "nativeLabel": "Cebuano",
        "countryCode": "PH",
        "countryCodes": [
            {"countryCode": "PH", "flag": "🇵🇭"}
        ]
    },
    {
        "label": "Chichewa",
        "code": "ny",
        "seamlessCode": "nya",
        "nativeLabel": "Chichewa",
        "countryCode": "MW",
        "countryCodes": [
            {"countryCode": "MW", "flag": "🇲🇼"}
        ]
    },
    {
        "label": "Croatian",
        "code": "hr",
        "seamlessCode": "hrv",
        "nativeLabel": "Hrvatski",
        "countryCode": "HR",
        "countryCodes": [
            {"countryCode": "HR", "flag": "🇭🇷"}
        ]
    },
    {
        "label": "Estonian",
        "code": "et",
        "seamlessCode": "est",
        "nativeLabel": "Eesti",
        "countryCode": "EE",
        "countryCodes": [
            {"countryCode": "EE", "flag": "🇪🇪"}
        ]
    },
    {
        "label": "Filipino",
        "code": "tl",
        "seamlessCode": "fil",
        "nativeLabel": "Filipino",
        "countryCode": "PH",
        "countryCodes": [
            {"countryCode": "PH", "flag": "🇵🇭"}
        ]
    },
    {
        "label": "Fulah",
        "code": "ff",
        "seamlessCode": "ful",
        "nativeLabel": "Fula",
        "countryCode": "SN",
        "countryCodes": [
            {"countryCode": "SN", "flag": "🇸🇳"}
        ]
    },
    {
        "label": "Galician",
        "code": "gl",
        "seamlessCode": "glg",
        "nativeLabel": "Galego",
        "countryCode": "ES",
        "countryCodes": [
            {"countryCode": "ES", "flag": "🇪🇸"}
        ]
    },
    {
        "label": "Lugandan",
        "code": "lg",
        "seamlessCode": "lug",
        "nativeLabel": "Luganda",
        "countryCode": "UG",
        "countryCodes": [
            {"countryCode": "UG", "flag": "🇺🇬"}
        ]
    },
    {
        "label": "Georgian",
        "code": "ka",
        "seamlessCode": "kat",
        "nativeLabel": "ქართული",
        "countryCode": "GE",
        "countryCodes": [
            {"countryCode": "GE", "flag": "🇬🇪"}
        ]
    },
    {
        "label": "Gujarati",
        "code": "gu",
        "seamlessCode": "guj",
        "nativeLabel": "ગુજરાતી",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Hausa",
        "code": "ha",
        "seamlessCode": "hau",
        "nativeLabel": "Hausa",
        "countryCode": "NG",
        "countryCodes": [
            {"countryCode": "NG", "flag": "🇳🇬"}
        ]
    },
    {
        "label": "Hebrew",
        "code": "he",
        "seamlessCode": "heb",
        "nativeLabel": "עברית",
        "countryCode": "IL",
        "countryCodes": [
            {"countryCode": "IL", "flag": "🇮🇱"}
        ]
    },
    {
        "label": "Hungarian",
        "code": "hu",
        "seamlessCode": "hun",
        "nativeLabel": "Magyar",
        "countryCode": "HU",
        "countryCodes": [
            {"countryCode": "HU", "flag": "🇭🇺"}
        ]
    },
    {
        "label": "Icelandic",
        "code": "is",
        "seamlessCode": "isl",
        "nativeLabel": "Íslenska",
        "countryCode": "IS",
        "countryCodes": [
            {"countryCode": "IS", "flag": "🇮🇸"}
        ]
    },
    {
        "label": "Igbo",
        "code": "ig",
        "seamlessCode": "ibo",
        "nativeLabel": "Igbo",
        "countryCode": "NG",
        "countryCodes": [
            {"countryCode": "NG", "flag": "🇳🇬"}
        ]
    },
    {
        "label": "Irish",
        "code": "ga",
        "seamlessCode": "gle",
        "nativeLabel": "Gaeilge",
        "countryCode": "IE",
        "countryCodes": [
            {"countryCode": "IE", "flag": "🇮🇪"}
        ]
    },
    {
        "label": "Javanese",
        "code": "jv",
        "seamlessCode": "jav",
        "nativeLabel": "Basa Jawa",
        "countryCode": "ID",
        "countryCodes": [
            {"countryCode": "ID", "flag": "🇮🇩"}
        ]
    },
    {
        "label": "Kabuverdianu",
        "code": "kea",
        "seamlessCode": "kea",
        "nativeLabel": "Kabuverdianu",
        "countryCode": "CV",
        "countryCodes": [
            {"countryCode": "CV", "flag": "🇨🇻"}
        ]
    },
    {
        "label": "Kannada",
        "code": "kn",
        "seamlessCode": "kan",
        "nativeLabel": "ಕನ್ನಡ",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Kazakh",
        "code": "kk",
        "seamlessCode": "kaz",
        "nativeLabel": "Қазақ",
        "countryCode": "KZ",
        "countryCodes": [
            {"countryCode": "KZ", "flag": "🇰🇿"}
        ]
    },
    {
        "label": "Khmer",
        "code": "km",
        "seamlessCode": "khm",
        "nativeLabel": "ខ្មែរ",
        "countryCode": "KH",
        "countryCodes": [
            {"countryCode": "KH", "flag": "🇰🇭"}
        ]
    },
    {
        "label": "Kurdish",
        "code": "ku",
        "seamlessCode": "kur",
        "nativeLabel": "Kurdî",
        "countryCode": "IQ",
        "countryCodes": [
            {"countryCode": "IQ", "flag": "🇮🇶"}
        ]
    },
    {
        "label": "Kyrgyz",
        "code": "ky",
        "seamlessCode": "kir",
        "nativeLabel": "Кыргызча",
        "countryCode": "KG",
        "countryCodes": [
            {"countryCode": "KG", "flag": "🇰🇬"}
        ]
    },
    {
        "label": "Lao",
        "code": "lo",
        "seamlessCode": "lao",
        "nativeLabel": "ລາວ",
        "countryCode": "LA",
        "countryCodes": [
            {"countryCode": "LA", "flag": "🇱🇦"}
        ]
    },
    {
        "label": "Latvian",
        "code": "lv",
        "seamlessCode": "lav",
        "nativeLabel": "Latviešu",
        "countryCode": "LV",
        "countryCodes": [
            {"countryCode": "LV", "flag": "🇱🇻"}
        ]
    },
    {
        "label": "Lingala",
        "code": "ln",
        "seamlessCode": "lin",
        "nativeLabel": "Lingála",
        "countryCode": "CD",
        "countryCodes": [
            {"countryCode": "CD", "flag": "🇨🇩"}
        ]
    },
    {
        "label": "Lithuanian",
        "code": "lt",
        "seamlessCode": "lit",
        "nativeLabel": "Lietuvių",
        "countryCode": "LT",
        "countryCodes": [
            {"countryCode": "LT", "flag": "🇱🇹"}
        ]
    },
    {
        "label": "Luo",
        "code": "luo",
        "seamlessCode": "luo",
        "nativeLabel": "Dholuo",
        "countryCode": "KE",
        "countryCodes": [
            {"countryCode": "KE", "flag": "🇰🇪"}
        ]
    },
    {
        "label": "Luxembourgish",
        "code": "lb",
        "seamlessCode": "ltz",
        "nativeLabel": "Lëtzebuergesch",
        "countryCode": "LU",
        "countryCodes": [
            {"countryCode": "LU", "flag": "🇱🇺"}
        ]
    },
    {
        "label": "Macedonian",
        "code": "mk",
        "seamlessCode": "mkd",
        "nativeLabel": "Македонски",
        "countryCode": "MK",
        "countryCodes": [
            {"countryCode": "MK", "flag": "🇲🇰"}
        ]
    },
    {
        "label": "Malayalam",
        "code": "ml",
        "seamlessCode": "mal",
        "nativeLabel": "മലയാളം",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Maltese",
        "code": "mt",
        "seamlessCode": "mlt",
        "nativeLabel": "Malti",
        "countryCode": "MT",
        "countryCodes": [
            {"countryCode": "MT", "flag": "🇲🇹"}
        ]
    },
    {
        "label": "Māori",
        "code": "mi",
        "seamlessCode": "mri",
        "nativeLabel": "Māori",
        "countryCode": "NZ",
        "countryCodes": [
            {"countryCode": "NZ", "flag": "🇳🇿"}
        ]
    },
    {
        "label": "Marathi",
        "code": "mr",
        "seamlessCode": "mar",
        "nativeLabel": "मराठी",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Mongolian",
        "code": "mn",
        "seamlessCode": "mon",
        "nativeLabel": "Монгол",
        "countryCode": "MN",
        "countryCodes": [
            {"countryCode": "MN", "flag": "🇲🇳"}
        ]
    },
    {
        "label": "Nepali",
        "code": "ne",
        "seamlessCode": "nep",
        "nativeLabel": "नेपाली",
        "countryCode": "NP",
        "countryCodes": [
            {"countryCode": "NP", "flag": "🇳🇵"}
        ]
    },
    {
        "label": "Northern Sotho",
        "code": "nso",
        "seamlessCode": "nso",
        "nativeLabel": "Sesotho sa Leboa",
        "countryCode": "ZA",
        "countryCodes": [
            {"countryCode": "ZA", "flag": "🇿🇦"}
        ]
    },
    {
        "label": "Norwegian",
        "code": "no",
        "seamlessCode": "nor",
        "nativeLabel": "Norsk",
        "countryCode": "NO",
        "countryCodes": [
            {"countryCode": "NO", "flag": "🇳🇴"}
        ]
    },
    {
        "label": "Occitan",
        "code": "oc",
        "seamlessCode": "oci",
        "nativeLabel": "Occitan",
        "countryCode": "FR",
        "countryCodes": [
            {"countryCode": "FR", "flag": "🇫🇷"}
        ]
    },
    {
        "label": "Odia",
        "code": "or",
        "seamlessCode": "ori",
        "nativeLabel": "ଓଡ଼ିଆ",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Pashto",
        "code": "ps",
        "seamlessCode": "pus",
        "nativeLabel": "پښتو",
        "countryCode": "AF",
        "countryCodes": [
            {"countryCode": "AF", "flag": "🇦🇫"}
        ]
    },
    {
        "label": "Persian",
        "code": "fa",
        "seamlessCode": "fas",
        "nativeLabel": "فارسی",
        "countryCode": "IR",
        "countryCodes": [
            {"countryCode": "IR", "flag": "🇮🇷"}
        ]
    },
    {
        "label": "Punjabi",
        "code": "pa",
        "seamlessCode": "pan",
        "nativeLabel": "ਪੰਜਾਬੀ",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "PK", "flag": "🇵🇰"}
        ]
    },
    {
        "label": "Serbian",
        "code": "sr",
        "seamlessCode": "srp",
        "nativeLabel": "Српски",
        "countryCode": "RS",
        "countryCodes": [
            {"countryCode": "RS", "flag": "🇷🇸"}
        ]
    },
    {
        "label": "Shona",
        "code": "sn",
        "seamlessCode": "sna",
        "nativeLabel": "ChiShona",
        "countryCode": "ZW",
        "countryCodes": [
            {"countryCode": "ZW", "flag": "🇿🇼"}
        ]
    },
    {
        "label": "Sindhi",
        "code": "sd",
        "seamlessCode": "snd",
        "nativeLabel": "سنڌي",
        "countryCode": "PK",
        "countryCodes": [
            {"countryCode": "PK", "flag": "🇵🇰"}
        ]
    },
    {
        "label": "Slovenian",
        "code": "sl",
        "seamlessCode": "slv",
        "nativeLabel": "Slovenščina",
        "countryCode": "SI",
        "countryCodes": [
            {"countryCode": "SI", "flag": "🇸🇮"}
        ]
    },
    {
        "label": "Somali",
        "code": "so",
        "seamlessCode": "som",
        "nativeLabel": "Soomaali",
        "countryCode": "SO",
        "countryCodes": [
            {"countryCode": "SO", "flag": "🇸🇴"}
        ]
    },
    {
        "label": "Swahili",
        "code": "sw",
        "seamlessCode": "swa",
        "nativeLabel": "Kiswahili",
        "countryCode": "KE",
        "countryCodes": [
            {"countryCode": "KE", "flag": "🇰🇪"},
            {"countryCode": "TZ", "flag": "🇹🇿"}
        ]
    },
    {
        "label": "Tajik",
        "code": "tg",
        "seamlessCode": "tgk",
        "nativeLabel": "Тоҷикӣ",
        "countryCode": "TJ",
        "countryCodes": [
            {"countryCode": "TJ", "flag": "🇹🇯"}
        ]
    },
    {
        "label": "Telugu",
        "code": "te",
        "seamlessCode": "tel",
        "nativeLabel": "తెలుగు",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"}
        ]
    },
    {
        "label": "Thai",
        "code": "th",
        "seamlessCode": "tha",
        "nativeLabel": "ไทย",
        "countryCode": "TH",
        "countryCodes": [
            {"countryCode": "TH", "flag": "🇹🇭"}
        ]
    },
    {
        "label": "Umbundu",
        "code": "umb",
        "seamlessCode": "umb",
        "nativeLabel": "Umbundu",
        "countryCode": "AO",
        "countryCodes": [
            {"countryCode": "AO", "flag": "🇦🇴"}
        ]
    },
    {
        "label": "Urdu",
        "code": "ur",
        "seamlessCode": "urd",
        "nativeLabel": "اُردو",
        "countryCode": "PK",
        "countryCodes": [
            {"countryCode": "PK", "flag": "🇵🇰"}
        ]
    },
    {
        "label": "Ukrainian",
        "code": "uk",
        "seamlessCode": "ukr",
        "nativeLabel": "Українська",
        "countryCode": "UA",
        "countryCodes": [
            {"countryCode": "UA", "flag": "🇺🇦"}
        ]
    },
    {
        "label": "Uzbek",
        "code": "uz",
        "seamlessCode": "uzb",
        "nativeLabel": "Oʻzbek",
        "countryCode": "UZ",
        "countryCodes": [
            {"countryCode": "UZ", "flag": "🇺🇿"}
        ]
    },
    {
        "label": "Vietnamese",
        "code": "vi",
        "seamlessCode": "vie",
        "nativeLabel": "Tiếng Việt",
        "countryCode": "VN",
        "countryCodes": [
            {"countryCode": "VN", "flag": "🇻🇳"}
        ]
    },
    {
        "label": "Welsh",
        "code": "cy",
        "seamlessCode": "cym",
        "nativeLabel": "Cymraeg",
        "countryCode": "GB",
        "countryCodes": [
            {"countryCode": "GB", "flag": "🇬🇧"}
        ]
    },
    {
        "label": "Wolof",
        "code": "wo",
        "seamlessCode": "wol",
        "nativeLabel": "Wolof",
        "countryCode": "SN",
        "countryCodes": [
            {"countryCode": "SN", "flag": "🇸🇳"}
        ]
    },
    {
        "label": "Xhosa",
        "code": "xh",
        "seamlessCode": "xho",
        "nativeLabel": "isiXhosa",
        "countryCode": "ZA",
        "countryCodes": [
            {"countryCode": "ZA", "flag": "🇿🇦"}
        ]
    },
    {
        "label": "Zulu",
        "code": "zu",
        "seamlessCode": "zul",
        "nativeLabel": "isiZulu",
        "countryCode": "ZA",
        "countryCodes": [
            {"countryCode": "ZA", "flag": "🇿🇦"}
        ]
    }
];

export const languages: LanguageInfo[] = [...languagesRaw].sort((a, b) => a.label.localeCompare(b.label));

// YouTube-specific language locales for channel localization
// These map to YouTube's exact locale codes and include regional variants
const youtubeLanguagesRaw: LanguageInfo[] = [
    {
        "label": "Afrikaans",
        "code": "af",
        "seamlessCode": "afr",
        "nativeLabel": "Afrikaans",
        "countryCode": "ZA",
        "countryCodes": [{"countryCode": "ZA", "flag": "🇿🇦"}],
        "youtubeCode": "af"
    },
    {
        "label": "Amharic",
        "code": "am",
        "seamlessCode": "amh",
        "nativeLabel": "አማርኛ",
        "countryCode": "ET",
        "countryCodes": [{"countryCode": "ET", "flag": "🇪🇹"}],
        "youtubeCode": "am"
    },
    {
        "label": "Arabic",
        "code": "ar",
        "seamlessCode": "arb",
        "nativeLabel": "العربية",
        "countryCode": "AE",
        "countryCodes": [
            {"countryCode": "SA", "flag": "🇸🇦"},
            {"countryCode": "AE", "flag": "🇦🇪"},
            {"countryCode": "EG", "flag": "🇪🇬"}
        ],
        "youtubeCode": "ar"
    },
    {
        "label": "Assamese",
        "code": "as",
        "seamlessCode": "asm",
        "nativeLabel": "অসমীয়া",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "as"
    },
    {
        "label": "Azerbaijani",
        "code": "az",
        "seamlessCode": "aze",
        "nativeLabel": "Azərbaycanca",
        "countryCode": "AZ",
        "countryCodes": [{"countryCode": "AZ", "flag": "🇦🇿"}],
        "youtubeCode": "az"
    },
    {
        "label": "Belarusian",
        "code": "be",
        "seamlessCode": "bel",
        "nativeLabel": "Беларуская",
        "countryCode": "BY",
        "countryCodes": [{"countryCode": "BY", "flag": "🇧🇾"}],
        "youtubeCode": "be"
    },
    {
        "label": "Bulgarian",
        "code": "bg",
        "seamlessCode": "bul",
        "nativeLabel": "Български",
        "countryCode": "BG",
        "countryCodes": [{"countryCode": "BG", "flag": "🇧🇬"}],
        "youtubeCode": "bg"
    },
    {
        "label": "Bengali",
        "code": "bn",
        "seamlessCode": "ben",
        "nativeLabel": "বাংলা",
        "countryCode": "BD",
        "countryCodes": [
            {"countryCode": "BD", "flag": "🇧🇩"},
            {"countryCode": "IN", "flag": "🇮🇳"}
        ],
        "youtubeCode": "bn"
    },
    {
        "label": "Bosnian",
        "code": "bs",
        "seamlessCode": "bos",
        "nativeLabel": "Bosanski",
        "countryCode": "BA",
        "countryCodes": [{"countryCode": "BA", "flag": "🇧🇦"}],
        "youtubeCode": "bs"
    },
    {
        "label": "Catalan",
        "code": "ca",
        "seamlessCode": "cat",
        "nativeLabel": "Català",
        "countryCode": "ES",
        "countryCodes": [{"countryCode": "ES", "flag": "🇪🇸"}],
        "youtubeCode": "ca"
    },
    {
        "label": "Czech",
        "code": "cs",
        "seamlessCode": "ces",
        "nativeLabel": "Čeština",
        "countryCode": "CZ",
        "countryCodes": [{"countryCode": "CZ", "flag": "🇨🇿"}],
        "youtubeCode": "cs"
    },
    {
        "label": "Danish",
        "code": "da",
        "seamlessCode": "dan",
        "nativeLabel": "Dansk",
        "countryCode": "DK",
        "countryCodes": [{"countryCode": "DK", "flag": "🇩🇰"}],
        "youtubeCode": "da"
    },
    {
        "label": "German",
        "code": "de",
        "seamlessCode": "deu",
        "nativeLabel": "Deutsch",
        "countryCode": "DE",
        "countryCodes": [
            {"countryCode": "DE", "flag": "🇩🇪"},
            {"countryCode": "AT", "flag": "🇦🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"}
        ],
        "youtubeCode": "de"
    },
    {
        "label": "Greek",
        "code": "el",
        "seamlessCode": "ell",
        "nativeLabel": "Ελληνικά",
        "countryCode": "GR",
        "countryCodes": [
            {"countryCode": "GR", "flag": "🇬🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ],
        "youtubeCode": "el"
    },
    {
        "label": "English",
        "code": "en",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "GB",
        "countryCodes": [
            {"countryCode": "GB", "flag": "🇬🇧"},
            {"countryCode": "AU", "flag": "🇦🇺"},
            {"countryCode": "CA", "flag": "🇨🇦"},
            {"countryCode": "NZ", "flag": "🇳🇿"}
        ],
        "youtubeCode": "en"
    },
    {
        "label": "English",
        "code": "en-GB",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "GB",
        "countryCodes": [{"countryCode": "GB", "flag": "🇬🇧"}],
        "youtubeCode": "en_GB"
    },
    {
        "label": "English",
        "code": "en-US",
        "seamlessCode": "eng",
        "nativeLabel": "English",
        "countryCode": "US",
        "countryCodes": [{"countryCode": "US", "flag": "🇺🇸"}],
        "youtubeCode": "en_US"
    },
    {
        "label": "Spanish",
        "code": "es",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "MX",
        "countryCodes": [
            {"countryCode": "MX", "flag": "🇲🇽"},
            {"countryCode": "ES", "flag": "🇪🇸"},
            {"countryCode": "AR", "flag": "🇦🇷"},
            {"countryCode": "CO", "flag": "🇨🇴"}
        ],
        "youtubeCode": "es"
    },
    {
        "label": "Spanish",
        "code": "es-ES",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "ES",
        "countryCodes": [{"countryCode": "ES", "flag": "🇪🇸"}],
        "youtubeCode": "es_ES"
    },
    {
        "label": "Spanish",
        "code": "es-MX",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "MX",
        "countryCodes": [{"countryCode": "MX", "flag": "🇲🇽"}],
        "youtubeCode": "es_MX"
    },
    {
        "label": "Spanish",
        "code": "es-US",
        "seamlessCode": "spa",
        "nativeLabel": "Español",
        "countryCode": "US",
        "countryCodes": [{"countryCode": "US", "flag": "🇺🇸"}],
        "youtubeCode": "es_US"
    },
    {
        "label": "Spanish (Latin America)",
        "code": "es-419",
        "seamlessCode": "spa",
        "nativeLabel": "Español (Latinoamérica)",
        "countryCode": "MX",
        "countryCodes": [{"countryCode": "MX", "flag": "🇲🇽"}],
        "youtubeCode": "es_419"
    },
    {
        "label": "Estonian",
        "code": "et",
        "seamlessCode": "est",
        "nativeLabel": "Eesti",
        "countryCode": "EE",
        "countryCodes": [{"countryCode": "EE", "flag": "🇪🇪"}],
        "youtubeCode": "et"
    },
    {
        "label": "Basque",
        "code": "eu",
        "seamlessCode": "eus",
        "nativeLabel": "Euskara",
        "countryCode": "ES",
        "countryCodes": [{"countryCode": "ES", "flag": "🇪🇸"}],
        "youtubeCode": "eu"
    },
    {
        "label": "Persian",
        "code": "fa",
        "seamlessCode": "fas",
        "nativeLabel": "فارسی",
        "countryCode": "IR",
        "countryCodes": [{"countryCode": "IR", "flag": "🇮🇷"}],
        "youtubeCode": "fa"
    },
    {
        "label": "Finnish",
        "code": "fi",
        "seamlessCode": "fin",
        "nativeLabel": "Suomi",
        "countryCode": "FI",
        "countryCodes": [{"countryCode": "FI", "flag": "🇫🇮"}],
        "youtubeCode": "fi"
    },
    {
        "label": "Filipino",
        "code": "tl",
        "seamlessCode": "fil",
        "nativeLabel": "Filipino",
        "countryCode": "PH",
        "countryCodes": [{"countryCode": "PH", "flag": "🇵🇭"}],
        "youtubeCode": "fil"
    },
    {
        "label": "French",
        "code": "fr",
        "seamlessCode": "fra",
        "nativeLabel": "Français",
        "countryCode": "FR",
        "countryCodes": [
            {"countryCode": "FR", "flag": "🇫🇷"},
            {"countryCode": "BE", "flag": "🇧🇪"},
            {"countryCode": "CH", "flag": "🇨🇭"}
        ],
        "youtubeCode": "fr"
    },
    {
        "label": "French",
        "code": "fr-CA",
        "seamlessCode": "fra",
        "nativeLabel": "Français",
        "countryCode": "CA",
        "countryCodes": [{"countryCode": "CA", "flag": "🇨🇦"}],
        "youtubeCode": "fr_CA"
    },
    {
        "label": "Galician",
        "code": "gl",
        "seamlessCode": "glg",
        "nativeLabel": "Galego",
        "countryCode": "ES",
        "countryCodes": [{"countryCode": "ES", "flag": "🇪🇸"}],
        "youtubeCode": "gl"
    },
    {
        "label": "Gujarati",
        "code": "gu",
        "seamlessCode": "guj",
        "nativeLabel": "ગુજરાતી",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "gu"
    },
    {
        "label": "Hindi",
        "code": "hi",
        "seamlessCode": "hin",
        "nativeLabel": "हिन्दी",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "hi"
    },
    {
        "label": "Hindi",
        "code": "hi-IN",
        "seamlessCode": "hin",
        "nativeLabel": "हिन्दी",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "hi_IN"
    },
    {
        "label": "Croatian",
        "code": "hr",
        "seamlessCode": "hrv",
        "nativeLabel": "Hrvatski",
        "countryCode": "HR",
        "countryCodes": [{"countryCode": "HR", "flag": "🇭🇷"}],
        "youtubeCode": "hr"
    },
    {
        "label": "Hungarian",
        "code": "hu",
        "seamlessCode": "hun",
        "nativeLabel": "Magyar",
        "countryCode": "HU",
        "countryCodes": [{"countryCode": "HU", "flag": "🇭🇺"}],
        "youtubeCode": "hu"
    },
    {
        "label": "Armenian",
        "code": "hy",
        "seamlessCode": "hye",
        "nativeLabel": "Հայերեն",
        "countryCode": "AM",
        "countryCodes": [{"countryCode": "AM", "flag": "🇦🇲"}],
        "youtubeCode": "hy"
    },
    {
        "label": "Indonesian",
        "code": "id",
        "seamlessCode": "ind",
        "nativeLabel": "Bahasa Indonesia",
        "countryCode": "ID",
        "countryCodes": [{"countryCode": "ID", "flag": "🇮🇩"}],
        "youtubeCode": "id"
    },
    {
        "label": "Icelandic",
        "code": "is",
        "seamlessCode": "isl",
        "nativeLabel": "Íslenska",
        "countryCode": "IS",
        "countryCodes": [{"countryCode": "IS", "flag": "🇮🇸"}],
        "youtubeCode": "is"
    },
    {
        "label": "Italian",
        "code": "it",
        "seamlessCode": "ita",
        "nativeLabel": "Italiano",
        "countryCode": "IT",
        "countryCodes": [
            {"countryCode": "IT", "flag": "🇮🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"}
        ],
        "youtubeCode": "it"
    },
    {
        "label": "Hebrew",
        "code": "he",
        "seamlessCode": "heb",
        "nativeLabel": "עברית",
        "countryCode": "IL",
        "countryCodes": [{"countryCode": "IL", "flag": "🇮🇱"}],
        "youtubeCode": "iw"
    },
    {
        "label": "Japanese",
        "code": "ja",
        "seamlessCode": "jpn",
        "nativeLabel": "日本語",
        "countryCode": "JP",
        "countryCodes": [{"countryCode": "JP", "flag": "🇯🇵"}],
        "youtubeCode": "ja"
    },
    {
        "label": "Georgian",
        "code": "ka",
        "seamlessCode": "kat",
        "nativeLabel": "ქართული",
        "countryCode": "GE",
        "countryCodes": [{"countryCode": "GE", "flag": "🇬🇪"}],
        "youtubeCode": "ka"
    },
    {
        "label": "Kazakh",
        "code": "kk",
        "seamlessCode": "kaz",
        "nativeLabel": "Қазақ",
        "countryCode": "KZ",
        "countryCodes": [{"countryCode": "KZ", "flag": "🇰🇿"}],
        "youtubeCode": "kk"
    },
    {
        "label": "Khmer",
        "code": "km",
        "seamlessCode": "khm",
        "nativeLabel": "ខ្មែរ",
        "countryCode": "KH",
        "countryCodes": [{"countryCode": "KH", "flag": "🇰🇭"}],
        "youtubeCode": "km"
    },
    {
        "label": "Kannada",
        "code": "kn",
        "seamlessCode": "kan",
        "nativeLabel": "ಕನ್ನಡ",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "kn"
    },
    {
        "label": "Korean",
        "code": "ko",
        "seamlessCode": "kor",
        "nativeLabel": "한국어",
        "countryCode": "KR",
        "countryCodes": [{"countryCode": "KR", "flag": "🇰🇷"}],
        "youtubeCode": "ko"
    },
    {
        "label": "Kyrgyz",
        "code": "ky",
        "seamlessCode": "kir",
        "nativeLabel": "Кыргызча",
        "countryCode": "KG",
        "countryCodes": [{"countryCode": "KG", "flag": "🇰🇬"}],
        "youtubeCode": "ky"
    },
    {
        "label": "Lao",
        "code": "lo",
        "seamlessCode": "lao",
        "nativeLabel": "ລາວ",
        "countryCode": "LA",
        "countryCodes": [{"countryCode": "LA", "flag": "🇱🇦"}],
        "youtubeCode": "lo"
    },
    {
        "label": "Lugandan",
        "code": "lg",
        "seamlessCode": "lug",
        "nativeLabel": "Luganda",
        "countryCode": "UG",
        "countryCodes": [{"countryCode": "UG", "flag": "🇺🇬"}],
        "youtubeCode": "lg"
    },
    {
        "label": "Lithuanian",
        "code": "lt",
        "seamlessCode": "lit",
        "nativeLabel": "Lietuvių",
        "countryCode": "LT",
        "countryCodes": [{"countryCode": "LT", "flag": "🇱🇹"}],
        "youtubeCode": "lt"
    },
    {
        "label": "Latvian",
        "code": "lv",
        "seamlessCode": "lav",
        "nativeLabel": "Latviešu",
        "countryCode": "LV",
        "countryCodes": [{"countryCode": "LV", "flag": "🇱🇻"}],
        "youtubeCode": "lv"
    },
    {
        "label": "Macedonian",
        "code": "mk",
        "seamlessCode": "mkd",
        "nativeLabel": "Македонски",
        "countryCode": "MK",
        "countryCodes": [{"countryCode": "MK", "flag": "🇲🇰"}],
        "youtubeCode": "mk"
    },
    {
        "label": "Malayalam",
        "code": "ml",
        "seamlessCode": "mal",
        "nativeLabel": "മലയാളം",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "ml"
    },
    {
        "label": "Mongolian",
        "code": "mn",
        "seamlessCode": "mon",
        "nativeLabel": "Монгол",
        "countryCode": "MN",
        "countryCodes": [{"countryCode": "MN", "flag": "🇲🇳"}],
        "youtubeCode": "mn"
    },
    {
        "label": "Marathi",
        "code": "mr",
        "seamlessCode": "mar",
        "nativeLabel": "मराठी",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "mr"
    },
    {
        "label": "Malay",
        "code": "ms",
        "seamlessCode": "msa",
        "nativeLabel": "Bahasa Melayu",
        "countryCode": "MY",
        "countryCodes": [
            {"countryCode": "MY", "flag": "🇲🇾"},
            {"countryCode": "BN", "flag": "🇧🇳"},
            {"countryCode": "SG", "flag": "🇸🇬"}
        ],
        "youtubeCode": "ms"
    },
    {
        "label": "Burmese",
        "code": "my",
        "seamlessCode": "mya",
        "nativeLabel": "မြန်မာ",
        "countryCode": "MM",
        "countryCodes": [{"countryCode": "MM", "flag": "🇲🇲"}],
        "youtubeCode": "my"
    },
    {
        "label": "Nepali",
        "code": "ne",
        "seamlessCode": "nep",
        "nativeLabel": "नेपाली",
        "countryCode": "NP",
        "countryCodes": [{"countryCode": "NP", "flag": "🇳🇵"}],
        "youtubeCode": "ne"
    },
    {
        "label": "Dutch",
        "code": "nl",
        "seamlessCode": "nld",
        "nativeLabel": "Nederlands",
        "countryCode": "NL",
        "countryCodes": [
            {"countryCode": "NL", "flag": "🇳🇱"},
            {"countryCode": "BE", "flag": "🇧🇪"}
        ],
        "youtubeCode": "nl"
    },
    {
        "label": "Norwegian",
        "code": "no",
        "seamlessCode": "nor",
        "nativeLabel": "Norsk",
        "countryCode": "NO",
        "countryCodes": [{"countryCode": "NO", "flag": "🇳🇴"}],
        "youtubeCode": "no"
    },
    {
        "label": "Odia",
        "code": "or",
        "seamlessCode": "ori",
        "nativeLabel": "ଓଡ଼ିଆ",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "or"
    },
    {
        "label": "Punjabi",
        "code": "pa",
        "seamlessCode": "pan",
        "nativeLabel": "ਪੰਜਾਬੀ",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "PK", "flag": "🇵🇰"}
        ],
        "youtubeCode": "pa"
    },
    {
        "label": "Polish",
        "code": "pl",
        "seamlessCode": "pol",
        "nativeLabel": "Polski",
        "countryCode": "PL",
        "countryCodes": [{"countryCode": "PL", "flag": "🇵🇱"}],
        "youtubeCode": "pl"
    },
    {
        "label": "Portuguese",
        "code": "pt",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "BR",
        "countryCodes": [
            {"countryCode": "PT", "flag": "🇵🇹"},
            {"countryCode": "BR", "flag": "🇧🇷"},
            {"countryCode": "AO", "flag": "🇦🇴"},
            {"countryCode": "MZ", "flag": "🇲🇿"}
        ],
        "youtubeCode": "pt"
    },
    {
        "label": "Portuguese",
        "code": "pt-BR",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "BR",
        "countryCodes": [{"countryCode": "BR", "flag": "🇧🇷"}],
        "youtubeCode": "pt_BR"
    },
    {
        "label": "Portuguese",
        "code": "pt-PT",
        "seamlessCode": "por",
        "nativeLabel": "Português",
        "countryCode": "PT",
        "countryCodes": [{"countryCode": "PT", "flag": "🇵🇹"}],
        "youtubeCode": "pt_PT"
    },
    {
        "label": "Romanian",
        "code": "ro",
        "seamlessCode": "ron",
        "nativeLabel": "Română",
        "countryCode": "RO",
        "countryCodes": [
            {"countryCode": "RO", "flag": "🇷🇴"},
            {"countryCode": "MD", "flag": "🇲🇩"}
        ],
        "youtubeCode": "ro"
    },
    {
        "label": "Russian",
        "code": "ru",
        "seamlessCode": "rus",
        "nativeLabel": "Русский",
        "countryCode": "RU",
        "countryCodes": [
            {"countryCode": "RU", "flag": "🇷🇺"},
            {"countryCode": "BY", "flag": "🇧🇾"},
            {"countryCode": "KZ", "flag": "🇰🇿"}
        ],
        "youtubeCode": "ru"
    },
    {
        "label": "Sinhala",
        "code": "si",
        "seamlessCode": "sin",
        "nativeLabel": "සිංහල",
        "countryCode": "LK",
        "countryCodes": [{"countryCode": "LK", "flag": "🇱🇰"}],
        "youtubeCode": "si"
    },
    {
        "label": "Slovak",
        "code": "sk",
        "seamlessCode": "slk",
        "nativeLabel": "Slovenčina",
        "countryCode": "SK",
        "countryCodes": [{"countryCode": "SK", "flag": "🇸🇰"}],
        "youtubeCode": "sk"
    },
    {
        "label": "Slovenian",
        "code": "sl",
        "seamlessCode": "slv",
        "nativeLabel": "Slovenščina",
        "countryCode": "SI",
        "countryCodes": [{"countryCode": "SI", "flag": "🇸🇮"}],
        "youtubeCode": "sl"
    },
    {
        "label": "Albanian",
        "code": "sq",
        "seamlessCode": "sqi",
        "nativeLabel": "Shqip",
        "countryCode": "AL",
        "countryCodes": [{"countryCode": "AL", "flag": "🇦🇱"}],
        "youtubeCode": "sq"
    },
    {
        "label": "Serbian",
        "code": "sr",
        "seamlessCode": "srp",
        "nativeLabel": "Српски",
        "countryCode": "RS",
        "countryCodes": [{"countryCode": "RS", "flag": "🇷🇸"}],
        "youtubeCode": "sr"
    },
    {
        "label": "Swedish",
        "code": "sv",
        "seamlessCode": "swe",
        "nativeLabel": "Svenska",
        "countryCode": "SE",
        "countryCodes": [
            {"countryCode": "SE", "flag": "🇸🇪"},
            {"countryCode": "FI", "flag": "🇫🇮"}
        ],
        "youtubeCode": "sv"
    },
    {
        "label": "Swahili",
        "code": "sw",
        "seamlessCode": "swa",
        "nativeLabel": "Kiswahili",
        "countryCode": "KE",
        "countryCodes": [
            {"countryCode": "KE", "flag": "🇰🇪"},
            {"countryCode": "TZ", "flag": "🇹🇿"}
        ],
        "youtubeCode": "sw"
    },
    {
        "label": "Tamil",
        "code": "ta",
        "seamlessCode": "tam",
        "nativeLabel": "தமிழ்",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "LK", "flag": "🇱🇰"},
            {"countryCode": "SG", "flag": "🇸🇬"}
        ],
        "youtubeCode": "ta"
    },
    {
        "label": "Telugu",
        "code": "te",
        "seamlessCode": "tel",
        "nativeLabel": "తెలుగు",
        "countryCode": "IN",
        "countryCodes": [{"countryCode": "IN", "flag": "🇮🇳"}],
        "youtubeCode": "te"
    },
    {
        "label": "Thai",
        "code": "th",
        "seamlessCode": "tha",
        "nativeLabel": "ไทย",
        "countryCode": "TH",
        "countryCodes": [{"countryCode": "TH", "flag": "🇹🇭"}],
        "youtubeCode": "th"
    },
    {
        "label": "Turkish",
        "code": "tr",
        "seamlessCode": "tur",
        "nativeLabel": "Türkçe",
        "countryCode": "TR",
        "countryCodes": [
            {"countryCode": "TR", "flag": "🇹🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ],
        "youtubeCode": "tr"
    },
    {
        "label": "Ukrainian",
        "code": "uk",
        "seamlessCode": "ukr",
        "nativeLabel": "Українська",
        "countryCode": "UA",
        "countryCodes": [{"countryCode": "UA", "flag": "🇺🇦"}],
        "youtubeCode": "uk"
    },
    {
        "label": "Urdu",
        "code": "ur",
        "seamlessCode": "urd",
        "nativeLabel": "اُردو",
        "countryCode": "PK",
        "countryCodes": [{"countryCode": "PK", "flag": "🇵🇰"}],
        "youtubeCode": "ur"
    },
    {
        "label": "Uzbek",
        "code": "uz",
        "seamlessCode": "uzb",
        "nativeLabel": "Oʻzbek",
        "countryCode": "UZ",
        "countryCodes": [{"countryCode": "UZ", "flag": "🇺🇿"}],
        "youtubeCode": "uz"
    },
    {
        "label": "Vietnamese",
        "code": "vi",
        "seamlessCode": "vie",
        "nativeLabel": "Tiếng Việt",
        "countryCode": "VN",
        "countryCodes": [{"countryCode": "VN", "flag": "🇻🇳"}],
        "youtubeCode": "vi"
    },
    {
        "label": "Chinese",
        "code": "zh-CN",
        "seamlessCode": "cmn",
        "nativeLabel": "中文",
        "countryCode": "CN",
        "countryCodes": [{"countryCode": "CN", "flag": "🇨🇳"}],
        "youtubeCode": "zh_CN"
    },
    {
        "label": "Chinese",
        "code": "zh-HK",
        "seamlessCode": "yue",
        "nativeLabel": "中文",
        "countryCode": "HK",
        "countryCodes": [{"countryCode": "HK", "flag": "🇭🇰"}],
        "youtubeCode": "zh_HK"
    },
    {
        "label": "Chinese",
        "code": "zh-TW",
        "seamlessCode": "cmn",
        "nativeLabel": "中文",
        "countryCode": "TW",
        "countryCodes": [{"countryCode": "TW", "flag": "🇹🇼"}],
        "youtubeCode": "zh_TW"
    },
    {
        "label": "Chinese",
        "code": "zh",
        "seamlessCode": "cmn",
        "nativeLabel": "中文",
        "countryCode": "CN",
        "countryCodes": [
            {"countryCode": "CN", "flag": "🇨🇳"},
            {"countryCode": "TW", "flag": "🇹🇼"},
            {"countryCode": "HK", "flag": "🇭🇰"}
        ],
        "youtubeCode": "zh"
    },
    {
        "label": "Zulu",
        "code": "zu",
        "seamlessCode": "zul",
        "nativeLabel": "isiZulu",
        "countryCode": "ZA",
        "countryCodes": [{"countryCode": "ZA", "flag": "🇿🇦"}],
        "youtubeCode": "zu"
    }
];

export const youtubeLanguages: LanguageInfo[] = [...youtubeLanguagesRaw].sort((a, b) => a.label.localeCompare(b.label));

export const chooseLanguageTranslations: { [key: string]: string } = {
    "bg": "Изберете език",
    "zh": "选择语言",
    "ar": "اختر اللغة",
    "hr": "Odaberite jezik",
    "cs": "Vyberte jazyk",
    "da": "Vælg sprog",
    "nl": "Kies taal",
    "en": "Choose language",
    "fi": "Valitse kieli",
    "tl": "Pumili ng wika",
    "fr": "Choisissez la langue",
    "de": "Sprache wählen",
    "el": "Επιλέξτε γλώσσα",
    "hi": "भाषा चुनें",
    "id": "Pilih bahasa",
    "it": "Scegli la lingua",
    "ja": "言語を選択",
    "ko": "언어 선택",
    "ms": "Pilih bahasa",
    "pl": "Wybierz język",
    "pt": "Escolha o idioma",
    "ro": "Alege limba",
    "ru": "Выберите язык",
    "sk": "Vyberte jazyk",
    "es": "Elige idioma",
    "es-419": "Elige idioma",
    "sv": "Välj språk",
    "ta": "மொழியைத் தேர்ந்தெடுங்கள்",
    "tr": "Dil seçin",
    "uk": "Оберіть мову",
    "lg": "Londa olulimi"
}

// Map of YouTube regional codes to friendly names and flags
const youtubeRegionalInfo: { [key: string]: { name: string; flag: string; countryCode: string } } = {
    '419': { name: 'Latin America', flag: '🌎', countryCode: 'MX' }, // Use globe for Latin America, default to MX
    'US': { name: 'United States', flag: '🇺🇸', countryCode: 'US' },
    'GB': { name: 'United Kingdom', flag: '🇬🇧', countryCode: 'GB' },
    'AU': { name: 'Australia', flag: '🇦🇺', countryCode: 'AU' },
    'CA': { name: 'Canada', flag: '🇨🇦', countryCode: 'CA' },
    'IN': { name: 'India', flag: '🇮🇳', countryCode: 'IN' },
    'BR': { name: 'Brazil', flag: '🇧🇷', countryCode: 'BR' },
    'PT': { name: 'Portugal', flag: '🇵🇹', countryCode: 'PT' },
    'MX': { name: 'Mexico', flag: '🇲🇽', countryCode: 'MX' },
    'AR': { name: 'Argentina', flag: '🇦🇷', countryCode: 'AR' },
    'CO': { name: 'Colombia', flag: '🇨🇴', countryCode: 'CO' },
    'CL': { name: 'Chile', flag: '🇨🇱', countryCode: 'CL' },
    'PE': { name: 'Peru', flag: '🇵🇪', countryCode: 'PE' },
    'VE': { name: 'Venezuela', flag: '🇻🇪', countryCode: 'VE' },
    'CN': { name: 'China', flag: '🇨🇳', countryCode: 'CN' },
    'TW': { name: 'Taiwan', flag: '🇹🇼', countryCode: 'TW' },
    'HK': { name: 'Hong Kong', flag: '🇭🇰', countryCode: 'HK' },
    'JP': { name: 'Japan', flag: '🇯🇵', countryCode: 'JP' },
    'KR': { name: 'Korea', flag: '🇰🇷', countryCode: 'KR' },
    'DE': { name: 'Germany', flag: '🇩🇪', countryCode: 'DE' },
    'AT': { name: 'Austria', flag: '🇦🇹', countryCode: 'AT' },
    'CH': { name: 'Switzerland', flag: '🇨🇭', countryCode: 'CH' },
    'FR': { name: 'France', flag: '🇫🇷', countryCode: 'FR' },
    'IT': { name: 'Italy', flag: '🇮🇹', countryCode: 'IT' },
    'NL': { name: 'Netherlands', flag: '🇳🇱', countryCode: 'NL' },
    'BE': { name: 'Belgium', flag: '🇧🇪', countryCode: 'BE' },
    'RU': { name: 'Russia', flag: '🇷🇺', countryCode: 'RU' },
    'PL': { name: 'Poland', flag: '🇵🇱', countryCode: 'PL' },
    'TR': { name: 'Turkey', flag: '🇹🇷', countryCode: 'TR' },
    'SA': { name: 'Saudi Arabia', flag: '🇸🇦', countryCode: 'SA' },
    'AE': { name: 'UAE', flag: '🇦🇪', countryCode: 'AE' },
    'EG': { name: 'Egypt', flag: '🇪🇬', countryCode: 'EG' },
    'ZA': { name: 'South Africa', flag: '🇿🇦', countryCode: 'ZA' },
    'NG': { name: 'Nigeria', flag: '🇳🇬', countryCode: 'NG' },
    'KE': { name: 'Kenya', flag: '🇰🇪', countryCode: 'KE' },
    'PH': { name: 'Philippines', flag: '🇵🇭', countryCode: 'PH' },
    'ID': { name: 'Indonesia', flag: '🇮🇩', countryCode: 'ID' },
    'MY': { name: 'Malaysia', flag: '🇲🇾', countryCode: 'MY' },
    'SG': { name: 'Singapore', flag: '🇸🇬', countryCode: 'SG' },
    'TH': { name: 'Thailand', flag: '🇹🇭', countryCode: 'TH' },
    'VN': { name: 'Vietnam', flag: '🇻🇳', countryCode: 'VN' },
    'ES': { name: 'Spain', flag: '🇪🇸', countryCode: 'ES' },
    'IE': { name: 'Ireland', flag: '🇮🇪', countryCode: 'IE' },
    'NZ': { name: 'New Zealand', flag: '🇳🇿', countryCode: 'NZ' },
    'SE': { name: 'Sweden', flag: '🇸🇪', countryCode: 'SE' },
    'NO': { name: 'Norway', flag: '🇳🇴', countryCode: 'NO' },
    'DK': { name: 'Denmark', flag: '🇩🇰', countryCode: 'DK' },
    'FI': { name: 'Finland', flag: '🇫🇮', countryCode: 'FI' },
    'GR': { name: 'Greece', flag: '🇬🇷', countryCode: 'GR' },
    'CZ': { name: 'Czech Republic', flag: '🇨🇿', countryCode: 'CZ' },
    'RO': { name: 'Romania', flag: '🇷🇴', countryCode: 'RO' },
    'HU': { name: 'Hungary', flag: '🇭🇺', countryCode: 'HU' },
    'SK': { name: 'Slovakia', flag: '🇸🇰', countryCode: 'SK' },
    'UA': { name: 'Ukraine', flag: '🇺🇦', countryCode: 'UA' },
    'IL': { name: 'Israel', flag: '🇮🇱', countryCode: 'IL' },
    'PK': { name: 'Pakistan', flag: '🇵🇰', countryCode: 'PK' },
    'BD': { name: 'Bangladesh', flag: '🇧🇩', countryCode: 'BD' },
    'LK': { name: 'Sri Lanka', flag: '🇱🇰', countryCode: 'LK' },
};

function normalizeLanguageLookupCode(code: string): string {
    return code.trim().replace(/_/g, '-');
}

function toBcp47LookupCode(code: string): string {
    const parts = normalizeLanguageLookupCode(code).split('-').filter(Boolean);
    if (parts.length === 0) return '';
    const language = parts[0].toLowerCase();
    if (parts.length === 1) return language;
    const region = parts[1].toUpperCase();
    return `${language}-${region}`;
}

function findCatalogLanguage(code: string): LanguageInfo | undefined {
    return youtubeLanguages.find(lang => lang.code === code)
        || languages.find(lang => lang.code === code);
}

export function getLanguageInfoByCode(code: string | null | undefined): LanguageInfo | undefined {
    // Track records occasionally reach here without a languageCode; returning
    // undefined lets callers fall back to their own label instead of throwing.
    if (typeof code !== 'string' || !code) return undefined;

    // First try to find in youtubeLanguages (includes regional variants)
    let language = findCatalogLanguage(code);

    const normalizedCode = normalizeLanguageLookupCode(code);
    const bcp47Code = toBcp47LookupCode(code);

    // Accept es-mx / ES-MX / es_MX as the catalog es-MX entry.
    if (!language && bcp47Code && bcp47Code !== code) {
        language = findCatalogLanguage(bcp47Code);
    }
    
    // Fallback to regular languages array if not found
    if (!language) {
        const aliasedCode = normalizedCode.toLowerCase() === 'fil'
            ? 'tl'
            : normalizedCode.toLowerCase().startsWith('fil-')
                ? normalizedCode.replace(/^fil/i, 'tl')
                : '';

        if (aliasedCode) {
            language = getLanguageInfoByCode(aliasedCode);
        }
    }
    
    // If still not found and code has a regional suffix (e.g., "es-419", "en-GB")
    // Try to find the base language and create a modified version
    if (!language && normalizedCode.includes('-')) {
        const [baseLang, regionRaw] = normalizedCode.split('-');
        const region = regionRaw?.toUpperCase();
        const baseLanguage = findCatalogLanguage(baseLang.toLowerCase())
            || findCatalogLanguage(baseLang);
        
        if (baseLanguage) {
            const regionInfo = region ? youtubeRegionalInfo[region] : undefined;
            const regionName = regionInfo?.name || region;
            const regionFlag = regionInfo?.flag || baseLanguage.countryCodes[0]?.flag || '';
            const regionCountryCode = regionInfo?.countryCode
                || (/^[A-Z]{2}$/.test(region || '') ? region : baseLanguage.countryCode);
            
            // Return a copy with modified label and flag for the region
            return {
                ...baseLanguage,
                code: bcp47Code || code, // Keep a normalized regional code
                label: `${baseLanguage.label} (${regionName})`,
                countryCode: regionCountryCode,
                countryCodes: [{ countryCode: regionCountryCode, flag: regionFlag }],
            };
        }
    }
    
    return language;
}

/**
 * Country flag for a language code. Regional BCP-47 suffixes win
 * (`pt-BR` → BR, `pt-PT` → PT) over the base-language catalog default.
 */
export function getCountryCodeForLanguage(code: string | null | undefined): string | null {
    if (typeof code !== 'string' || !code) return null;
    const info = getLanguageInfoByCode(code);
    if (info?.countryCode) return info.countryCode;

    const region = toBcp47LookupCode(code).split('-')[1];
    if (region && youtubeRegionalInfo[region]) {
        return youtubeRegionalInfo[region].countryCode;
    }
    if (region && /^[A-Z]{2}$/.test(region)) {
        return region;
    }
    return null;
}

function lookupFlagSelection(
    selections: Record<string, string> | null | undefined,
    languageCode: string,
): string | undefined {
    if (!selections || !languageCode) return undefined;
    if (selections[languageCode]) return selections[languageCode];

    const normalized = normalizeLanguageLookupCode(languageCode);
    if (selections[normalized]) return selections[normalized];

    const bcp47 = toBcp47LookupCode(languageCode);
    if (bcp47 && selections[bcp47]) return selections[bcp47];

    const target = bcp47.toLowerCase() || normalized.toLowerCase();
    const match = Object.keys(selections).find((key) => (
        normalizeLanguageLookupCode(key).toLowerCase() === target
        || toBcp47LookupCode(key).toLowerCase() === target
    ));
    return match ? selections[match] : undefined;
}

/**
 * Resolve the flag to show for a language. Video/user overrides apply only
 * when they target this exact locale — a stored `pt` → BR pick must not
 * overwrite `pt-PT`.
 */
export function resolveFlagCountryCode(
    languageCode: string | null | undefined,
    selections?: Record<string, string> | null,
): string | null {
    if (typeof languageCode !== 'string' || !languageCode) return null;
    return lookupFlagSelection(selections, languageCode)
        || getCountryCodeForLanguage(languageCode);
}

export function getLanguageInfoByLabel(label: string): LanguageInfo | undefined {
    return languages.find(lang => lang.label === label);
}

export function getLanguageSwitcherDisplayTextTranslation(code: string): string {
    return chooseLanguageTranslations[code]
}

// Get the language label by code and country code because some country codes are shared between languages
export function getLabelByCodeAndCountryCode(code: string, countryCode: string): string | null {
    const language = languages.find(lang =>
        lang.code === code && lang.countryCodes.some(cc => cc.countryCode === countryCode)
    );
    return language ? language.label : null;
}

export function getFlagByCodeAndCountryCode(countryCode: string, code: string): string | null {
    // Use getLanguageInfoByCode which handles regional variants (e.g., es-419)
    const language = getLanguageInfoByCode(code);

    if (language) {
        // First try to find by the specified country code
        const country = language.countryCodes.find(c => c.countryCode === countryCode);
        if (country) {
            return country.flag;
        }
        // Fall back to the first flag if the specific country code isn't found
        // This handles regional variants where we set a single flag
        if (language.countryCodes.length > 0) {
            return language.countryCodes[0].flag;
        }
    }

    return null;
}

/**
 * Get the Seamless M2M language code for a given ISO 639-1 language code
 * @param code - ISO 639-1 language code (e.g., 'en', 'es')
 * @returns The corresponding Seamless M2M language code, defaults to 'eng' if not found
 */
export function getSeamlessLanguageCode(code: string): string {
    const language = getLanguageInfoByCode(code);
    return language?.seamlessCode || 'eng';
}

export function getLanguageInfoBySeamlessCode(seamlessCode: string): LanguageInfo | undefined {
    return languages.find(lang => lang.seamlessCode === seamlessCode);
}

export function getLanguageCodeBySeamlessCode(seamlessCode: string): string {
    const language = getLanguageInfoBySeamlessCode(seamlessCode);
    return language?.code || '';
}

/**
 * Get language info by YouTube locale code (e.g., 'en_US', 'pt_BR')
 * @param youtubeCode - YouTube locale code
 * @returns LanguageInfo if found, undefined otherwise
 */
export function getLanguageInfoByYouTubeCode(youtubeCode: string): LanguageInfo | undefined {
    return youtubeLanguages.find(lang => lang.youtubeCode === youtubeCode);
}

/**
 * Get the YouTube locale code for a given language code
 * @param code - Language code (e.g., 'en', 'pt-BR', 'zh-CN')
 * @returns YouTube locale code (e.g., 'en', 'pt_BR', 'zh_CN')
 */
export function getYouTubeLocaleCode(code: string): string {
    const language = youtubeLanguages.find(lang => lang.code === code);
    return language?.youtubeCode || code; // Fallback to original code if not found
}

/**
 * Convert YouTube locale code (e.g., 'pt_BR') to our internal code (e.g., 'pt-BR')
 * @param youtubeCode - YouTube locale code
 * @returns Internal language code
 */
export function youtubeCodeToInternalCode(youtubeCode: string): string {
    const language = getLanguageInfoByYouTubeCode(youtubeCode);
    return language?.code || youtubeCode.replace('_', '-');
}

/**
 * Convert internal code (e.g., 'pt-BR') to YouTube locale code (e.g., 'pt_BR')
 * @param internalCode - Internal language code
 * @returns YouTube locale code
 */
export function internalCodeToYouTubeCode(internalCode: string): string {
    return getYouTubeLocaleCode(internalCode);
}

/**
 * Normalize YouTube locale codes to our internal language codes.
 * Handles cases where YouTube adds region suffixes (e.g., 'fr' -> 'fr_FR', 'hi' -> 'hi_IN')
 * 
 * Strategy:
 * 1. If it's a known YouTube locale code in our system, return the corresponding internal code
 * 2. If it's a simple language code (e.g., 'fr', 'hi'), return as-is
 * 3. If it has a locale suffix (e.g., 'fr_FR'), try to map to our base language or locale variant
 * 
 * @param youtubeCode - YouTube locale code (e.g., 'fr_FR', 'hi_IN', 'pt_BR')
 * @returns Normalized internal language code (e.g., 'fr', 'hi', 'pt-BR')
 */
export function normalizeYouTubeLocale(youtubeCode: string): string {
    // Try exact match first
    const exactMatch = getLanguageInfoByYouTubeCode(youtubeCode);
    if (exactMatch) {
        return exactMatch.code;
    }
    
    // Check if it's a simple language code (no underscore)
    if (!youtubeCode.includes('_')) {
        const simpleMatch = getLanguageInfoByCode(youtubeCode);
        return simpleMatch ? simpleMatch.code : youtubeCode;
    }
    
    // Extract base language from locale (e.g., 'fr_FR' -> 'fr', 'hi_IN' -> 'hi')
    const baseLang = youtubeCode.split('_')[0];
    
    // Check if we have the base language in our system
    const baseMatch = getLanguageInfoByCode(baseLang);
    if (baseMatch) {
        // YouTube added a region suffix to a language we support
        // Use the base language code (e.g., 'fr' instead of 'fr_FR')
        return baseMatch.code;
    }
    
    // Convert underscore to hyphen for locale variants we might support
    // (e.g., 'pt_BR' -> 'pt-BR')
    return youtubeCode.replace('_', '-');
}

/**
 * Get language info by YouTube code with fallback to normalized base language.
 * This is useful when YouTube returns locale codes we don't explicitly have in our system.
 * 
 * @param youtubeCode - YouTube locale code
 * @returns LanguageInfo if found, undefined otherwise
 */
export function getLanguageInfoByYouTubeCodeWithFallback(youtubeCode: string): LanguageInfo | undefined {
    // Try exact match first
    let langInfo = getLanguageInfoByYouTubeCode(youtubeCode);
    if (langInfo) {
        return langInfo;
    }
    
    // Try normalized code
    const normalizedCode = normalizeYouTubeLocale(youtubeCode);
    return getLanguageInfoByCode(normalizedCode);
}

/**
 * Check if a base language has regional variants in the YouTube languages list.
 * For example: 'pt' has variants 'pt-BR' and 'pt-PT'
 * 
 * @param baseCode - Base language code (e.g., 'pt', 'en', 'es')
 * @returns true if regional variants exist
 */
export function hasRegionalVariants(baseCode: string): boolean {
    // Check if there are any languages in youtubeLanguages that start with this base code
    // and have a hyphen (indicating a regional variant)
    return youtubeLanguages.some(lang => 
        lang.code !== baseCode && 
        lang.code.startsWith(baseCode + '-')
    );
}

/**
 * Get YouTube languages filtered for channel localization dropdown.
 * Removes base languages that have regional variants (e.g., removes 'pt' if 'pt-BR', 'pt-PT' exist)
 * This is specifically for YouTube channel localization where regional variants are explicitly supported.
 * 
 * @returns Filtered array of LanguageInfo suitable for YouTube channel localization
 */
export function getYouTubeLanguagesForChannelLocalization(): LanguageInfo[] {
    const baseLanguagesWithVariants = new Set<string>();
    
    // First pass: identify base languages that have regional variants
    youtubeLanguages.forEach(lang => {
        if (lang.code.includes('-')) {
            // This is a regional variant (e.g., 'pt-BR', 'en-US')
            // Extract base language (e.g., 'pt', 'en')
            const baseLang = lang.code.split('-')[0];
            baseLanguagesWithVariants.add(baseLang);
        }
    });
    
    // Second pass: filter out base languages that have variants
    return youtubeLanguages.filter(lang => {
        // If this language has no hyphen, it's a base language
        if (!lang.code.includes('-')) {
            // Exclude it if it has regional variants
            return !baseLanguagesWithVariants.has(lang.code);
        }
        // Keep all regional variants
        return true;
    });
}

/**
 * Extract the base language code from a language code (with or without region).
 * Used for translation APIs which typically use base language codes.
 * 
 * Examples:
 * - 'pt-BR' -> 'pt'
 * - 'en-US' -> 'en'
 * - 'fr' -> 'fr'
 * 
 * @param languageCode - Language code (can be base or regional variant)
 * @returns Base language code for translation
 */
export function getBaseLanguageForTranslation(languageCode: string): string {
    // If it has a hyphen, extract the base language
    if (languageCode.includes('-')) {
        return languageCode.split('-')[0];
    }
    // Already a base language
    return languageCode;
}